import { render, staticRenderFns } from "./downloadlogtable.vue?vue&type=template&id=0af82630&scoped=true&"
import script from "./downloadlogtable.vue?vue&type=script&lang=js&"
export * from "./downloadlogtable.vue?vue&type=script&lang=js&"
import style0 from "./downloadlogtable.vue?vue&type=style&index=0&id=0af82630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af82630",
  null
  
)

export default component.exports